import {
  Button,
  Tabs,
  TabsList,
  TabsTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import React from 'react';
import {
  PiBoatThin,
  PiCircleThin,
  PiDiamondThin,
  PiRadio,
  PiWaveSquare,
  PiDrone,
} from 'react-icons/pi';
import { cn } from '@ais-ui/utils';
import { useLocalization } from '@ais-ui/locale-management';
import { TbTemperature } from 'react-icons/tb';
import { GhVirtualAton } from '../../../assets/icons/GhVirtualAton';
import { HoverLabelTargetType } from './TargetHoverLabelForm';

interface TabButtonProps {
  icon: React.ElementType;
  value: string;
  onClick: (value: HoverLabelTargetType) => void;
  tooltipText: string;
}

interface TabsComponentProps {
  setTab: React.Dispatch<React.SetStateAction<HoverLabelTargetType>>;
  tab: HoverLabelTargetType;
}

const TabButton = ({
  icon: Icon,
  value,
  onClick,
  tooltipText,
}: TabButtonProps) => {
  return (
    <Tooltip>
      <TabsTrigger asChild value={value}>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            className={cn('justify-center')}
            onClick={() => onClick(value as HoverLabelTargetType)}
          >
            <Icon
              className={cn('size-6', 'group-hover/btn:text-primary')}
            />
          </Button>
        </TooltipTrigger>
      </TabsTrigger>
      <TooltipContent className="ml-4">{tooltipText}</TooltipContent>
    </Tooltip>
  );
};

export const TargetHoverLabelTabs = ({ tab, setTab }: TabsComponentProps) => {
  const { messages } = useLocalization();
  const onClick = (value: HoverLabelTargetType) => {
    setTab(value);
  };
  return (
    <Tabs value={tab} className="px-6 pb-6 pt-2">
      <TabsList>
        <TabButton
          icon={PiBoatThin}
          value="vessel"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverVesselTypeLabel}
        ></TabButton>
        <TabButton
          icon={PiDiamondThin}
          value="aton"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverAtonTypeLabel}
        ></TabButton>
        <TabButton
          icon={GhVirtualAton}
          value="virtualAton"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverVirtualAtonTypeLabel}
        ></TabButton>
        <TabButton
          icon={TbTemperature}
          value="methyd"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverMethydTypeLabel}
        ></TabButton>
        <TabButton
          icon={PiCircleThin}
          value="baseStation"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverBaseStationTypeLabel}
        ></TabButton>
        <TabButton
          icon={PiRadio}
          value="radar"
          onClick={onClick}
          tooltipText={messages.settingsMapTargetHoverRadarTypeLabel}
        ></TabButton>
        <TabButton
          icon={PiWaveSquare}
          value="das"
          onClick={onClick}
          tooltipText="DAS"
        ></TabButton>
        <TabButton
          icon={PiDrone}
          value="drone"
          onClick={onClick}
          tooltipText="Drone"
        ></TabButton>
      </TabsList>
    </Tabs>
  );
};
